import { enableProdMode, LOCALE_ID, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';

import { ENV, TELEMETRY_CONFIG } from '@environments/environment';

import { provideUiTour } from 'ngx-ui-tour-md-menu';
import { provideMTranslate, MTranslatePipe } from '@mercadona/core/translate';
import { provideMPlatform, MPlatformEnvironment } from '@mercadona/core/platform';
import { getUseCasesProviders } from '@/di/use-cases/use-cases-providers';
import { getRepositoriesProviders } from '@/di/repositories/repositories-providers';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorSectionsInterceptor } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';
import { MTelemetryInterceptor, MTelemetryModule } from '@mercadona/core/telemetry';
import { ApiInterceptor } from '@services/api/api.interceptor.service';
import { PtrabSessionInterceptor } from '@services/interceptors/ptrab-session-interceptor/ptrab-session-interceptor.service';
import { DatePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { MSnackbarService } from '@mercadona/components-musi/snackbar';
import { provideLottieOptions } from 'ngx-lottie';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { PipesModule } from '@app/presentation/pipes/pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MLoggerModule } from '@mercadona/core/logger';
import { MStorageModule } from '@mercadona/core/storage';
import { AppComponent } from '@app/app.component';
import { provideMIconRegistryPath, URL_BUCKET_MUSI } from '@mercadona/icons';

if (ENV.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AngularFireModule.initializeApp({
        ...ENV.firebaseConfig
      }),
      AngularFireAnalyticsModule,
      BrowserModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      MTelemetryModule.forRoot(TELEMETRY_CONFIG),
      PickerModule,
      PipesModule,
      FormsModule,
      ReactiveFormsModule,
      MLoggerModule.forRoot({
        logLevel: ENV.logLevel
      }),
      MStorageModule.forRoot(),
      MTranslatePipe
    ),
    provideUiTour(),
    provideMTranslate({ availableLanguages: ['es', 'pt'], defaultLanguage: 'es' }),
    provideMPlatform({
      appName: 'activo2-front-webapp',
      environment: ENV.name as MPlatformEnvironment
    }),
    getUseCasesProviders(),
    getRepositoriesProviders(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorSectionsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MTelemetryInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PtrabSessionInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es' },
    DatePipe,
    CookieService,
    MSnackbarService,
    provideMIconRegistryPath(URL_BUCKET_MUSI),
    provideHttpClient(withInterceptorsFromDi()),
    provideLottieOptions({
      player: () => import('lottie-web')
    }),
    provideZoneChangeDetection({ eventCoalescing: true })
  ]
})
  // eslint-disable-next-line no-console
  .catch((err) => console.log(err));
